import AnnouncementDialog from './announcement-dialog'

export default AnnouncementDialog
